const coronaHomeStoryStyle = Object.freeze({
  form: Object.freeze({
    buttonVariant: 'neutral',
  }),
  linkColor: 'positive',
});

export default coronaHomeStoryStyle;
